import JouvieINTJ from "../../../../assets/images/Jouvies/INTJ-J.png";
import JouvieINTP from "../../../../assets/images/Jouvies/INTP-T.png";
import JouvieENTJ from "../../../../assets/images/Jouvies/ENTJ-T.png";
import JouvieENTP from "../../../../assets/images/Jouvies/ENTP-T.png";

import JouvieINFJ from "../../../../assets/images/Jouvies/INFJ-J.png";
import JouvieINFP from "../../../../assets/images/Jouvies/INFP-T.png";
import JouvieENFJ from "../../../../assets/images/Jouvies/ENFJ-T.png";
import JouvieENFP from "../../../../assets/images/Jouvies/ENFP-T.png";

import JouvieISTJ from "../../../../assets/images/Jouvies/ISTJ-T.png";
import JouvieISFJ from "../../../../assets/images/Jouvies/ISFJ-T.png";
import JouvieESTJ from "../../../../assets/images/Jouvies/ESTJ-T.png";
import JouvieESFJ from "../../../../assets/images/Jouvies/ESFJ-T.png";

import JouvieISTP from "../../../../assets/images/Jouvies/ISTP-T.png";
import JouvieISFP from "../../../../assets/images/Jouvies/ISFP-T.png";
import JouvieESTP from "../../../../assets/images/Jouvies/ESTP-T.png";
import JouvieESFP from "../../../../assets/images/Jouvies/ESFP-T.png";
import i18n from "@microdoing/shared/i18n";

export const MTBI_OPTIONS = (language = "en") => [
  {
    key: "INTJ",
    label: "INTJ",
    title: i18n.t("INTJ-title", { lng: language }),
    category: i18n.t("analysts"),
    description: i18n.t("INTJ-description", { lng: language }),
    image: JouvieINTJ,
  },
  {
    key: "INTP",
    label: "INTP",
    title: i18n.t("INTP-title", { lng: language }),
    description: i18n.t("INTP-description", { lng: language }),
    category: i18n.t("analysts"),
    image: JouvieINTP,
  },
  {
    key: "ENTJ",
    label: "ENTJ",
    title: i18n.t("ENTJ-title", { lng: language }),
    description: i18n.t("ENTJ-description", { lng: language }),
    category: i18n.t("analysts"),
    image: JouvieENTJ,
  },
  {
    key: "ENTP",
    label: "ENTP",
    title: i18n.t("ENTP-title", { lng: language }),
    description: i18n.t("ENTP-description", { lng: language }),
    category: i18n.t("analysts"),
    image: JouvieENTP,
  },
  //
  {
    key: "INFJ",
    label: "INFJ",
    title: i18n.t("INFJ-title", { lng: language }),
    description: i18n.t("INFJ-description", { lng: language }),
    category: i18n.t("diplomats"),
    image: JouvieINFJ,
  },
  {
    key: "INFP",
    label: "INFP",
    title: i18n.t("INFP-title", { lng: language }),
    description: i18n.t("INFP-description", { lng: language }),
    category: i18n.t("diplomats"),
    image: JouvieINFP,
  },
  {
    key: "ENFJ",
    label: "ENFJ",
    title: i18n.t("ENFJ-title", { lng: language }),
    description: i18n.t("ENFJ-description", { lng: language }),
    category: i18n.t("diplomats"),
    image: JouvieENFJ,
  },
  {
    key: "ENFP",
    label: "ENFP",
    title: i18n.t("ENFP-title", { lng: language }),
    description: i18n.t("ENFP-description", { lng: language }),
    category: i18n.t("diplomats"),
    image: JouvieENFP,
  },
  //
  {
    key: "ISTJ",
    label: "ISTJ",
    title: i18n.t("ISTJ-title", { lng: language }),
    description: i18n.t("ISTJ-description", { lng: language }),
    category: i18n.t("sentinels"),
    image: JouvieISTJ,
  },
  {
    key: "ISFJ",
    label: "ISFJ",
    title: i18n.t("ISFJ-title", { lng: language }),
    description: i18n.t("ISFJ-description", { lng: language }),
    category: i18n.t("sentinels"),
    image: JouvieISFJ,
  },
  {
    key: "ESTJ",
    label: "ESTJ",
    title: i18n.t("ESTJ-title", { lng: language }),
    description: i18n.t("ESTJ-description", { lng: language }),
    category: i18n.t("sentinels"),
    image: JouvieESTJ,
  },
  {
    key: "ESFJ",
    label: "ESFJ",
    title: i18n.t("ESFJ-title", { lng: language }),
    description: i18n.t("ESFJ-description", { lng: language }),
    category: i18n.t("sentinels"),
    image: JouvieESFJ,
  },
  //
  {
    key: "ISTP",
    label: "ISTP",
    title: i18n.t("ISTP-title", { lng: language }),
    description: i18n.t("ISTP-description", { lng: language }),
    category: i18n.t("explorers"),
    image: JouvieISTP,
  },
  {
    key: "ISFP",
    label: "ISFP",
    title: i18n.t("ISFP-title", { lng: language }),
    description: i18n.t("ISFP-description", { lng: language }),
    category: i18n.t("explorers"),
    image: JouvieISFP,
  },
  {
    key: "ESTP",
    label: "ESTP",
    title: i18n.t("ESTP-title", { lng: language }),
    description: i18n.t("ESTP-description", { lng: language }),
    category: i18n.t("explorers"),
    image: JouvieESTP,
  },
  {
    key: "ESFP",
    label: "ESFP",
    title: i18n.t("ESFP-title", { lng: language }),
    description: i18n.t("ESFP-description", { lng: language }),
    category: i18n.t("explorers"),
    image: JouvieESFP,
  },
];

export const getMbtiOptions = language => {
  return MTBI_OPTIONS(language);
};
